module.exports = __webpack_public_path__ + "img/banks.4e674111.png";